import { render, staticRenderFns } from "./404Page.vue?vue&type=template&id=dc6e1676&"
import script from "./404Page.vue?vue&type=script&lang=ts&"
export * from "./404Page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports